import script from "./MessageBox.vue?vue&type=script&setup=true&lang=ts"
export * from "./MessageBox.vue?vue&type=script&setup=true&lang=ts"

import "./MessageBox.vue?vue&type=style&index=0&id=0f0ab218&lang=scss"

const __exports__ = script;

export default __exports__